import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import AuthCallback from "@/pages/AuthCallback";
import "@/App.css";
const Planner = lazy(() => import("@/pages/Planner"));
const Schedule = lazy(() => import("@/pages/Schedule"));
const Today = lazy(() => import("@/pages/Today"));
const Blog = lazy(() => import("@/pages/Blog"));
const Library = lazy(() => import("@/pages/Library"));
const Reminders = lazy(() => import("@/pages/Reminders"));
const SavedPlans = lazy(() => import("@/pages/SavedPlans"));
const Login = lazy(() => import("@/pages/Login"));
const ForgotPassword = lazy(() => import("@/pages/ForgotPassword"));
const ResetPassword = lazy(() => import("@/pages/ResetPassword"));
const Pricing = lazy(() => import("@/pages/Pricing"));
const Learn = lazy(() => import("@/pages/Learn"));
const Article = lazy(() => import("@/pages/Article"));
const Referrals = lazy(() => import("@/pages/Referrals"));
const Privacy = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.Privacy })));
const Terms = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.Terms })));
const Refunds = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.Refunds })));
const DeleteAccountInfo = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.DeleteAccountInfo })));
const PaymentSuccess = lazy(() => import("@/pages/PaymentResult").then((m) => ({ default: m.PaymentSuccess })));
const PaymentCancel = lazy(() => import("@/pages/PaymentResult").then((m) => ({ default: m.PaymentCancel })));

function AppRouter() {
  const location = useLocation();
  // Emergent OAuth returns to <origin>/planner#session_id=... — process it first.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Suspense fallback={<div data-testid="page-loading" className="min-h-[60vh]" />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/today" element={<Today />} />
        <Route path="/planner" element={<Planner />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/schedule/:planId" element={<Schedule />} />
        <Route path="/library" element={<Library />} />
        <Route path="/learn" element={<Learn />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/learn/:slug" element={<Article />} />
        <Route path="/reminders" element={<Reminders />} />
        <Route path="/saved" element={<SavedPlans />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/referrals" element={<Referrals />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/refunds" element={<Refunds />} />
        <Route path="/delete-account" element={<DeleteAccountInfo />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      </Suspense>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="bottom-right" richColors theme="dark" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
